import EFPicture from 'elem/compCommon/EFPicture';
import IP68 from '@elem/SVGIcon/VanlifeRoadtrips/IP68';
import PlugAndPlay from '@elem/SVGIcon/PowerBackup/PlugAndPlay';
import Clock from 'elem/SVGIcon/PowerBackup/Clock';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function G() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('vanliferoadtrips');
    const { locale } = useRouter();
    const LOCAL_SITES: string[] = ['kr'];
    const icons: any = [
        {
            icon: <Clock />,
            text: t('secG_tag1'),
        },
        {
            icon: <PlugAndPlay />,
            text: t('secG_tag2'),
        },
        {
            icon: <IP68 />,
            text: t('secG_tag3'),
        },
    ];
    return (
        <div id="vanlife-roadtrips-G" className={`vanlife-roadtrips-G ${css['vanlife-roadtrips-G']}`}>
            <div className="img-box">
                <EFPicture
                    src={`/responsive/picture/vanlife-roadtrips/7${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.jpg`}
                    srcMobile={`/responsive/picture/vanlife-roadtrips/7_375${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.jpg`}
                    alt={t('secG_title')}
                />
                <div className="text-content">
                    <p className="title">{t('secG_title')}</p>
                    <p className="desc">{t('secG_desc')}</p>
                    <ul className="icons">
                        {icons?.map((icon: any) => (
                            <li className="icon-item" key={icon?.text}>
                                {icon?.icon}
                                <p className="icon-text">{icon?.text}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
